function incrementHandler(state: { value: number }) {
  state.value += 1;
}

function decrementHandler(state: { value: number }) {
  state.value -= 1;
}

export { incrementHandler, decrementHandler };
